var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import APIIN from "@/utils/APIIN";
import { call, put, takeLatest } from "redux-saga/effects";
import { GET_GST_CERT_LIST_REQUEST, getGstCertListFailure, getGstCertListSuccess } from "../../actions";
const onGstCertList = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            APIIN.get(`company/admin/gst-certificate/list?companyId=${(_a = action === null || action === void 0 ? void 0 : action.payload) === null || _a === void 0 ? void 0 : _a.companyId}`)
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* onGstCertListWorker(action) {
    try {
        const data = yield call(onGstCertList, action);
        yield put(getGstCertListSuccess(data));
    }
    catch (error) {
        yield put(getGstCertListFailure(error));
    }
}
export function* watchOnGstCertList() {
    yield takeLatest(GET_GST_CERT_LIST_REQUEST, onGstCertListWorker);
}
